import { useEffect, useState } from 'react';

export function useWindowSize() {
    const [windowSize, setWindowSize] = useState<any>({
        width: undefined,
        height: undefined,
    });

    function handleResize() {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleResize);

            handleResize();

            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);
    return windowSize;
}

export function validationHTML(value: string) {
    return /<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(
        value
    );
}

export function toPrice(price: number, scale?: number | 2): string {
    return String(((price * 100) / 100).toFixed(scale))
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export function formatDate(timestamp: string | number): string {
    if (!timestamp) return '';

    let date: Date;

    try {
        const parsed = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
        if (isNaN(parsed)) return '';

        date = new Date(parsed);
        if (isNaN(date.getTime())) return '';
    } catch {
        return '';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // meses são 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export function apenasNumeros(value: any) {
    if(value){
        let array = value.split(',');
        const arrayImoveis = array.map((x: any) => {
            return Number(x)
        })
        return arrayImoveis;
    }else{
        return [];
    }
}

export function arrumaData(value: any) {
    const split = value.split('-');
    if(split[0]?.length == 4){
        return split[2]+"/"+split[1]+"/"+split[0];
    }else{
        return value?.replaceAll("-","/");
    }
}

export function montaLinks(allRodape: any) {
    let links: { url: string; title: string; contador: number; }[] = []; // Array para armazenar os links
    let cont = 0;
    let total = 0;
    for (let i = 0; i < allRodape.length; i++) {
        let v = allRodape[i];
        let url_completa = ''
        let title = ''
        // Constrói a URL
        switch (cont) {
            case 0:
                url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/${v?.cidade ? v?.cidade : '-'}/${v?.bairro ? v?.bairro : '-'}/-/${v?.tipo ? v?.tipo : '-'}`.replaceAll(' ','-').toLowerCase();
                title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'} em ${v?.bairro ? v?.bairro + ' - '+v?.cidade : v?.cidade}`;
                cont++;
                break;
            case 1:
                url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/-/-/-/${v?.tipo ? v?.tipo : '-'}`.replaceAll(' ','-').toLowerCase();
                title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'}`;
                cont++;
                break;
            case 2:
                url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/${v?.cidade ? v?.cidade : '-'}/-/-/${v?.tipo ? v?.tipo : '-'}`.replaceAll(' ','-').toLowerCase();
                title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'} em ${v?.cidade}`;
                cont++;
                break;
            case 3:
                if(v?.dormitorios > 0){
                    url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/${v?.cidade ? v?.cidade : '-'}/-/-/-?dormitorios=${v?.dormitorios}`.replaceAll(' ','-').toLowerCase();
                    title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.dormitorios ? ' '+v?.dormitorios+' dormitórios' : ''}${v?.venda ? ' à venda' : ' para aluguel'} em ${v?.cidade}`;
                }
                cont = 0;
                break;
            default:
                url_completa = `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/${v?.cidade ? v?.cidade : '-'}/${v?.bairro ? v?.bairro : '-'}/-/${v?.tipo ? v?.tipo : '-'}`.replaceAll(' ','-').toLowerCase();
                title = `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'} em ${v?.bairro ? v?.bairro + ' - '+v?.cidade : v?.cidade}`;
                cont = 0;
                break;
        }

        if(v?.tipo && v?.empreendimento){
            const tituloExistente1 = links.some(link => link.title === title);

            if (!tituloExistente1) {
                links.push({url: `/imoveis/${v?.venda ? 'venda' : 'aluguel'}/-/-/${v?.empreendimento.replaceAll(" ","-").replaceAll("\n", '-')}/${v?.tipo}`.replaceAll(' ','-').toLowerCase(), title: `${v?.tipo ? v?.tipo : 'Imóveis'}${v?.venda ? ' à venda' : ' para aluguel'} Empreendimento ${v?.empreendimento}`, contador: cont});
                total++;
            }
        }

        const tituloExistente = links.some(link => link.title === title);

        if (!tituloExistente && title != '') {
            links.push({url: url_completa, title: title, contador: cont});
            total++;
            if(total >= 20)
                break;
        }
    }

    return links;
}

export function capitalizeWords(str: string): string {
    return str.replace(/(^|[ ,\-.])\w/g, function(char) {
        return char.toUpperCase();
    });
}

export function formatarDataEntrega(timestamp: number): string {
    const dataUTC = new Date(timestamp + new Date().getTimezoneOffset() * 60000);
    const agora = new Date();

    // Se a data estiver no passado, retorna null
    if (dataUTC < agora) {
        return 'false';
    }

    const opcoes = { month: "long", year: "numeric" } as const;
    return dataUTC.toLocaleDateString("pt-BR", opcoes);
}


export function arrumaUrlTiposSiteMaps(value: any, domain: any) {
    let allUrl: Array<string> = [];
    const transacao = value?.site?.transacoes[0].toLowerCase();
    value?.tipos.map((item: any)=>{
        if(item?.nome){
            allUrl.push((domain+"/imoveis/"+transacao+"/-/-/-/"+item?.nome+"").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
        }
    })
    if(value?.site?.transacoes?.length > 1){
        value?.tipos.map((item: any)=>{
            if(item?.nome){
                allUrl.push((domain+"/imoveis/"+value?.site?.transacoes[0].toLowerCase()+"/-/-/-/"+item?.nome+"").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
            }
        })
    }

    return allUrl;
}

export function arrumaUrlEmpreendimentosMaps(value: any,domain: any) {
    let allUrl: Array<string> = [];
    const transacao = value?.site?.transacoes[0].toLowerCase();
    if(value?.empreendimentos?.length > 0){
        value?.empreendimentos.map((item: any)=>{
            if(item?.nome){
                allUrl.push((domain+"/imoveis/"+transacao+"/-/-/"+item?.nome+"/-").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
            }
        })
        if(value?.site?.transacoes?.length > 1){
            value?.empreendimentos.map((item: any)=>{
                if(item?.nome){
                    allUrl.push((domain+"/imoveis/"+value?.site?.transacoes[1].toLowerCase()+"/-/-/"+item?.nome+"/-").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
                }
            })
        }
    }

    return allUrl;
}

export function arrumaUrlBairrosMaps(value: any,domain: any) {
    let allUrl: Array<string> = [];
    const transacao = value?.site?.transacoes[0].toLowerCase();
    value?.bairros.map((item: any)=>{
        if(item?.nome && item?.cidade?.nome){
            allUrl.push((domain+"/imoveis/"+transacao+"/"+item?.cidade?.nome+"/"+item?.nome+"/-/-").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
        }
    })
    if(value?.site?.transacoes?.length > 1){
        value?.bairros.map((item: any)=>{
            if(item?.nome && item?.cidade?.nome){
                allUrl.push((domain+"/imoveis/"+value?.site?.transacoes[1].toLowerCase()+"/"+item?.cidade?.nome+"/"+item?.nome+"/-/-").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
            }
        })
    }
    return allUrl;
}

export function arrumaUrlImoveisSiteMaps(value: any, domain: any) {
    let allUrl: Array<string> = [];
    let allUrl_fotos: Array<string> = [];
    if(value?.imoveis?.imoveis?.length > 0){
        value?.imoveis?.imoveis.map((item: any)=>{
            allUrl.push((domain+"/imoveis/"+(item?.venda? "venda": item?.aluguel ? "aluguel":"temporada")+"/"+(item?.cidade?.nome ? item?.cidade?.nome : '-')+"/"+(item?.bairro?.nome ? item?.bairro?.nome : '-')+"/-/"+(item?.tipo?.nome ? item?.tipo?.nome : '-')+"/"+item?.referencia+"/imovel/"+item?.id).replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
            allUrl_fotos.push(item?.fotos[0]?.url_foto)
        })
    }

    return [allUrl,allUrl_fotos];
}

export function arrumaUrlSitesMaps(value: any, dominio?: any) {
    let allUrl: Array<string> = [];
    allUrl.push(dominio)
    if(value?.site?.exibir_empreendimento){
        allUrl.push(dominio+"/condominios")
    }
    value?.site?.transacoes.map((item: any)=>{
        allUrl.push((dominio+"/imoveis/"+item.toLowerCase()+"/-/-/-/-").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
        allUrl.push((dominio+"/imoveis/"+item.toLowerCase()).replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
    })
    return allUrl;
}

export function arrumaUrlCidadesMaps(value: any,domain: any) {
    let allUrl: Array<string> = [];

    const transacao = value?.site?.transacoes[0].toLowerCase();
    value?.cidades.map((item: any)=>{
        if(item?.nome){
            allUrl.push((domain+"/imoveis/"+transacao+"/"+item?.nome+"/-/-/-").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
        }
    })
    if(value?.site?.transacoes?.length > 1){
        value?.cidades.map((item: any)=>{
            if(item?.nome){
                allUrl.push((domain+"/imoveis/"+value?.site?.transacoes[1].toLowerCase()+"/"+item?.nome+"/-/-/-").replaceAll(" ","-").replaceAll(">","-").replaceAll("<","-"))
            }
        })
    }

    return allUrl;
}

export function arrumaUrlBlogsMaps(value: any,domain: any) {
    let allUrl: Array<string> = [];

    value?.blogsBusca.map((item: any)=>{
        if(item?.id){
            allUrl.push(domain+"/blog/"+item?.id)
        }
    })

    return allUrl;
}

export function apenasArray(value: any) {
    return JSON.stringify(value).replaceAll(/[^0-9\,]/g,'');
}

export function MaskPhone(v: string): string {
    let valueInitial = v?.replace(/\D/g, '').replace(/^0/, '') || '';
    if (valueInitial.length >= 11) {
        valueInitial = valueInitial.replace(
            /^(\d\d)(\d{5})(\d{4}).*/,
            '($1) $2-$3'
        );
    } else if (valueInitial.length == 10) {
        valueInitial = valueInitial.replace(
            /^(\d\d)(\d{4})(\d{0,4}).*/,
            '($1) $2-$3'
        );
    } else if (valueInitial.length > 7) {
        valueInitial = valueInitial.replace(
            /^(\d\d)(\d{4})(\d{0,4}).*/,
            '($1) $2-$3'
        );
    } else if (valueInitial.length > 2) {
        valueInitial = valueInitial.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
    } else if (v?.trim() !== '') {
        valueInitial = valueInitial.replace(/^(\d*)/, '($1');
    }
    return valueInitial;
}

export function removerAcentos(str: string) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

interface Cidade {
  label: string;
  id: number;
}

export function linkifyCidades(
  textoHtml: string,
  cidades: Cidade[]
): string {
  if (!textoHtml || cidades.length === 0) return textoHtml;

  // Escapar caracteres especiais para regex
  const escapeRegExp = (string: string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Monta um regex com todas as cidades
  const cidadesRegex = new RegExp(
    `\\b(${cidades.map(c => escapeRegExp(c.label)).join('|')})\\b`,
    'gi'
  );

  // Substitui as cidades por links
  const textoLinkado = textoHtml.replace(cidadesRegex, match => {
    const cidadeEncoded = encodeURIComponent(match);
    return `<a title"Imóveis a venda em ${cidadeEncoded}" href="/imoveis/venda/${cidadeEncoded}/-/-/-">${match}</a>`;
  });

  return textoLinkado;
}

export function completarURL(url: string): string {
    const numBarras = (url.match(/\//g) || []).length; // Conta o número de ocorrências de '/' na string
    const barrasFaltando = 6 - numBarras; // Calcula quantas barras faltam

    if (barrasFaltando > 0) {
        return url + '/-'.repeat(barrasFaltando); // Adiciona '/' até completar 6
    } else {
        return url; // Retorna a URL original se já tiver 6 ou mais '/'
    }
}

export function formatCaracteristicas(caracteristicas: any[]): any {
    return caracteristicas.flatMap(caracteristica => {
      const { id, nome, imovel, condominio } = caracteristica;

      const formattedCaracteristicas = [];

      // Se for um item de condomínio
      if (condominio) {
        formattedCaracteristicas.push({
          label: `${nome} - condomínio`,
          value:  id
        });
      } else {
        formattedCaracteristicas.push({
            label: `${nome} - unidade`,
            value:  id
          });
      }

      return formattedCaracteristicas;
    });
};

export function isColorLight(hexColor: any) {
  if (!hexColor) return true;
  // Remove "#" se existir
  hexColor = hexColor.replace('#', '');

  // Se for cor reduzida tipo #fff
  if (hexColor.length === 3) {
    hexColor = hexColor.split('').map((x: any) => x + x).join('');
  }

  const r = parseInt(hexColor.substr(0,2),16);
  const g = parseInt(hexColor.substr(2,2),16);
  const b = parseInt(hexColor.substr(4,2),16);

  // Fórmula padrão de luminância relativa
  const luminance = (0.299*r + 0.587*g + 0.114*b)/255;

  return luminance > 0.7; // 0 = preto, 1 = branco (ajuste o threshold se quiser)
}

export function getYoutubeId(videoUrl = "") {
    let videoId = "";
    try {
        if (videoUrl.includes("v=")) {
        videoId = videoUrl.split("v=")[1].split("&")[0];
        } else {
        videoId = videoUrl.split("/").slice(-1)[0];
        }
        // Remove parâmetros extras se houver
        videoId = videoId.split("?")[0];

        // Verifica se tem 11 caracteres e é só letras/números/traço/underline
        if (/^[\w-]{11}$/.test(videoId)) {
        return videoId;
        }
        // Retorna "" se não for válido
        return "";
    } catch (e) {
        return "";
    }
}

export function ipToInt(ip: string): number {
    return ip.split('.').reduce((int, oct) => (int << 8) + parseInt(oct, 10), 0);
}

export function isIPInCIDR(ip: string, cidr: string): boolean {
    if (!cidr.includes('/')) {
        // Se não for CIDR, compara IP direto
        return ip === cidr;
    }
    const [range, bitsStr] = cidr.split('/');
    const bits = bitsStr ? parseInt(bitsStr, 10) : 32;
    const ipInt = ipToInt(ip);
    const rangeInt = ipToInt(range);
    const mask = ~(2 ** (32 - bits) - 1);

    return (ipInt & mask) === (rangeInt & mask);
}

export function isAllowedIP(ip: string, allowedCIDRs: string[]): boolean {
    return allowedCIDRs.some(cidr => isIPInCIDR(ip, cidr));
}

export function formatSelects(value: Array<any>, cidade_priorizada?: String): any {
    // Converte a string de IDs priorizados para um array
    if(!value)
        return [];
    if(!cidade_priorizada || cidade_priorizada == '' || cidade_priorizada == undefined){
        return value.map((v) => {
            if (v?.nome && v?.id) {
                return {
                    label: v?.nome?.trim(),
                    value: v?.id,
                    id_estado: v?.id_estado ? v?.id_estado : 0,
                };
            }
            return null;
        })
        .filter((v) => v);
    }

    const idsPriorizados = cidade_priorizada ? cidade_priorizada.split(',') : [];

    return value.map((v) => {
        if (v?.nome && v?.id) {
            return {
                label: v?.nome?.trim(),
                value: v?.id,
            };
        }
        return null;
    })
    .filter((v) => v)
    .sort((a, b) => {
        // Verifica se os valores não são nulos
        if (a && b) {
            // Verifica se os IDs estão entre os priorizados
            const aPriorizado = idsPriorizados.includes(a.value.toString());
            const bPriorizado = idsPriorizados.includes(b.value.toString());

            // Ordena com base na priorização
            if (aPriorizado && !bPriorizado) {
                return -1;
            } else if (!aPriorizado && bPriorizado) {
                return 1;
            } else {
                return 0;
            }
        }
        // Se um dos valores for nulo, mantenha a ordem original
        return 0;
    });
}

export function NumeroFormatado(numero: Number) {
    const numeroFormatado = numero.toLocaleString('pt-BR', { minimumFractionDigits: 2 , maximumFractionDigits: 2});
    return numeroFormatado;
}

export function cleanOrigin(url: string): string {
    const retorno = url.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
    return retorno.replaceAll('"',"")
}

export function formatSelectsTransacao(value: Array<any>): any {
    return value
        .map((v) => {
            if (v) {
                return {
                    label: v,
                    value: v,
                };
            }
            return null;
        })
        .filter((v) => v);
}

export function OnlyNumbersMask(initialValue: string): string {
    return (initialValue || '').replace(/\D/g, '');
}

export function BreakApart(itens: Array<any>, max: number): Array<any> {
    return itens.reduce((acumulador, item, indice) => {
        const grupo = Math.floor(indice / max);
        acumulador[grupo] = [...(acumulador[grupo] || []), item];
        return acumulador;
    }, []);
}
